export const resources_desktop_horizontal = {
    //sounds are loaded separately with super-mega-polished library which handles many different browsers starting even on loading stage:
    howler :
        [
            //
        ],
    //all other different resources (even those which configure the game logic) are able to be loaded with PIXI native loader:
    pixi :
        [
            "res/desktop_horizontal/background_utility.png",

            {name: "res/desktop_horizontal/mainbackground.jpg", rus: true},
            {name: "res/desktop_horizontal/tables/forward.png", rus: true},
            {name: "res/desktop_horizontal/tables/lose.png", rus: true},
            {name: "res/desktop_horizontal/tables/win.png", rus: true},

            "res/desktop_horizontal/fonts/font_points_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_bet_total_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_bet_up_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_bet_over_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_bet_down_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_score_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/font_credits_desktop_horizontal.xml",
            "res/desktop_horizontal/fonts/arial_black_10_desktop_horizontal.xml",

            "res/desktop_horizontal/cards.json",
            "res/desktop_horizontal/uiscene_common.json",
            "res/desktop_horizontal/skin_common.json",

            {name: "res/desktop_horizontal/skin.json", rus: true},
            {name: "res/desktop_horizontal/uiscene.json", rus: true},
        ]
};


//////////////////
// WEBPACK FOOTER
// ./res/desktop_horizontal/resources.es6
// module id = 111
// module chunks = 0